import {noop} from '@benchling/js-utils';
import React from 'react';

import {Status as AutomationFileStatusGraphQL} from 'graphql-client/__generated/graphqlGlobalTypes';
import {AutomationFileErrorInfo} from 'lab-automation/automation-files/LabAutomationConstants';

import {AutomationOutputFileGraphQL} from '../../../graphql-fragments/lab-automation/__generated/AutomationOutputFileGraphQL';
import {ResultBlobGraphQL} from '../../../graphql-fragments/results/__generated/ResultBlobGraphQL';
import FailedRunAutomationFileButton from './FailedRunAutomationFileButton';

interface FailedRunAutomationOutputFileButtonProps {
  automationOutputFile: AutomationOutputFileGraphQL & {
    status: AutomationFileStatusGraphQL.failed;
    blob: ResultBlobGraphQL;
    errors: AutomationFileErrorInfo;
  };
  isStale: boolean;
  runId: string | null;
  configName: string | null;
  locked: boolean;
  handleRefreshVersionedData: () => Promise<void>;
  updateAutomationOutputFiles: (automationOutputFiles: Array<AutomationOutputFileGraphQL>) => void;
  previousFileNames: Set<string>;
}

/**
 * This component represents an AutomationOutputFile with a FAILED status in a NoteLinkedAssayData.
 */
const FailedRunAutomationOutputFileButton: React.FunctionComponent<
  FailedRunAutomationOutputFileButtonProps
> = (props: FailedRunAutomationOutputFileButtonProps): JSX.Element => (
  <FailedRunAutomationFileButton
    automationFile={props.automationOutputFile}
    isStale={props.isStale}
    runId={props.runId}
    configName={props.configName}
    locked={props.locked}
    handleRefreshVersionedData={props.handleRefreshVersionedData}
    updateAutomationOutputFiles={props.updateAutomationOutputFiles}
    updateAutomationInputFile={noop}
    previousFileNames={props.previousFileNames}
  />
);

export default FailedRunAutomationOutputFileButton;
